/**
 * @package modules.backend.Entities
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Event
 */
import { Counter } from '@/modules/backend/Entities/Counter';
import { Type } from 'class-transformer';

export class Event {
  private readonly id!: number;

  private readonly name: string;

  private readonly details: string;

  @Type(() => Counter)
  private readonly counter: Counter;

  @Type(() => Date)
  private readonly timestamp: Date;

  public readonly total!: number;

  private read = false;

  constructor(name: string, counter: Counter, timestamp: Date, details = '') {
    this.name = name;
    this.counter = counter;
    this.timestamp = timestamp;
    this.details = details;
  }

  public doRead(): void {
    this.read = true;
  }

  public cancelRead(): void {
    this.read = false;
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getDetails(): string {
    return this.details || 'Не указано.';
  }

  public getCounter(): Counter {
    return this.counter;
  }

  public getTotal(): number {
    return this.total;
  }

  public get isRead(): boolean {
    return Boolean(this.read);
  }

  public get createdAt(): Date {
    return this.timestamp;
  }
}
